export class TakeSnapshotRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "isPitrOnDemand",
            "baseName": "isPitrOnDemand",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "vaultStorageTier",
            "baseName": "vaultStorageTier",
            "type": "VaultStorageTier",
            "format": ""
        },
        {
            "name": "backupType",
            "baseName": "backupType",
            "type": "TakeSnapshotRequestBackupTypeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TakeSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var TakeSnapshotRequestBackupTypeEnum;
(function (TakeSnapshotRequestBackupTypeEnum) {
    TakeSnapshotRequestBackupTypeEnum["Standard"] = "STANDARD";
    TakeSnapshotRequestBackupTypeEnum["Cdc"] = "CDC";
})(TakeSnapshotRequestBackupTypeEnum || (TakeSnapshotRequestBackupTypeEnum = {}));
